import { Component, signal } from '@angular/core';

import {ToastConfig} from '../../../services/toast.service';
import {ToastComponent} from '../toast.component';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [ToastComponent],
  templateUrl: './toast-container.component.html'
})
export class ToastContainerComponent {
  toasts = signal<ToastConfig[]>([]);

  addToast(config: ToastConfig): void {
    this.toasts.update(toasts => [config, ...toasts]);
  }

  removeToast(id: string): void {
    this.toasts.update(toasts => toasts.filter(t => t.id !== id));
  }

  getPositionClasses(): string {
    const position = this.toasts()[0]?.options?.position || 'top-right';

    const positions: Record<string, string> = {
      'top-left': 'top-4 left-4',
      'top-center': 'top-4 left-1/2 -translate-x-1/2',
      'top-right': 'top-4 right-4',
      'bottom-left': 'bottom-4 left-4',
      'bottom-center': 'bottom-4 left-1/2 -translate-x-1/2',
      'bottom-right': 'bottom-4 right-4'
    };
    return positions[position] || positions['top-right'];
  }
}
